import { PROSPECT_LIST, PROSPECT_LIST_SUCCESS, PROSPECT_LIST_FAIL } from "../actions/types";

const initialState = {
    pending: false,
    success: null,
    error: null,
    loading: true,
    data: [],
    otherInfo: {},
}

export default function(state = initialState, action){
    const{type, payload}=action;
    switch(type){
        case PROSPECT_LIST:
            return ({
                ...state,
                pending : true,
                success : null,
                error : null,
                data : null
            })

        case PROSPECT_LIST_SUCCESS:
            const { list, ...rest } = payload;
            console.log(payload)
            return ({
                ...state,
                pending : false,
                success : true,
                error : null,
                data : list || null,
                otherInfo : rest || {}
            })

        case PROSPECT_LIST_FAIL:
            return({
                pending : false,
                success : false,
                error : payload.error,
                data : null
            })
        
        default:
            return state
    }
}